import BackgroundIllustration from '@/assets/illustrations/BackgroundIllustration.svg';

export const AuthBackgroundIllustrations = () => (
  <>
    <BackgroundIllustration className="pointer-events-none fixed left-0 top-0 z-10 h-56 w-60 select-none text-[#101010] sm:h-[320px] sm:w-[420px]" />
    <BackgroundIllustration className="pointer-events-none fixed bottom-0 right-0 z-10 h-56 w-60 rotate-180 select-none text-[#101010] sm:h-[320px] sm:w-[420px]" />
  </>
);
